import { Link } from "react-router-dom";
import { useLang } from "../i18n";
import { api } from "../lib/api";
import { useEffect, useState } from "react";

export function Footer() {
  const { t } = useLang();
  const [logoUrl, setLogoUrl] = useState("/logo-wolf.png");
  useEffect(() => {
    api.get("/settings").then(({ data }) => {
      if (data.logo_url) setLogoUrl(data.logo_url);
    }).catch(() => {});
  }, []);
  return (
    <footer className="border-t border-[#1A1A1A] bg-[#050505]">
      <div className="max-w-7xl mx-auto px-5 md:px-8 py-14 grid gap-10 md:grid-cols-3">
        <div>
          <div className="flex items-center gap-2 mb-4">
            <img src={logoUrl} alt="WARDOGS" className="w-8 h-8" />
            <span className="font-display text-2xl tracking-wide">WARDOGS<span className="text-wardogs">.HQ</span></span>
          </div>
          <p className="text-sm text-steel max-w-xs">
            {t("footer.tag")}
          </p>
        </div>
        <div>
          <p className="hud-label mb-4">{t("footer.nav")}</p>
          <div className="flex flex-col gap-2">
            {["nav.game", "nav.streamers", "nav.youtube", "nav.giveaway", "nav.discord", "nav.donazione"].map((key, i) => (
              <Link key={key} to={["/", "/streamer", "/youtube", "/giveaway", "/discord", "/donazione"][i]} className="text-sm text-steel hover:text-wardogs transition-colors duration-300 w-fit">
                {t(key)}
              </Link>
            ))}
          </div>
        </div>
        <div>
          <p className="hud-label mb-4">{t("footer.sources")}</p>
          <div className="flex flex-col gap-2">
            <a href="https://bulkhead.com/games/wardogs/" target="_blank" rel="noopener noreferrer" className="text-sm text-steel hover:text-wardogs transition-colors duration-300 w-fit">Sito BULKHEAD</a>
            <a href="https://store.steampowered.com/app/1867240/WARDOGS/" target="_blank" rel="noopener noreferrer" className="text-sm text-steel hover:text-wardogs transition-colors duration-300 w-fit">Steam - Wishlist</a>
            <a href="https://www.twitch.tv/ilquartiermastro" target="_blank" rel="noopener noreferrer" className="text-sm text-steel hover:text-wardogs transition-colors duration-300 w-fit">Twitch - IlQuartiermastro</a>
          </div>
        </div>
      </div>
      <div className="border-t border-[#1A1A1A] py-5 flex flex-col md:flex-row items-center justify-center gap-3 md:gap-8 font-mono text-[10px] uppercase tracking-[0.3em] text-[#4A4D51]">
        <span>{t("footer.legal")}</span>
        <span className="flex items-center gap-6">
          <Link to="/termini" className="hover:text-wardogs transition-colors duration-300" data-testid="footer-termini-link">Termini di Servizio</Link>
          <Link to="/privacy" className="hover:text-wardogs transition-colors duration-300" data-testid="footer-privacy-link">Privacy Policy</Link>
          <Link to="/elimina-dati" className="hover:text-wardogs transition-colors duration-300" data-testid="footer-elimina-dati-link">Eliminazione Dati</Link>
          <Link to="/contattaci" className="hover:text-wardogs transition-colors duration-300" data-testid="footer-contattaci-link">{t("footer.contatti")}</Link>
          <Link to="/copyright" className="hover:text-wardogs transition-colors duration-300" data-testid="footer-copyright-link">Copyright</Link>
        </span>
      </div>
      <div className="pb-5 text-center font-mono text-[9px] uppercase tracking-[0.15em] text-[#3A3D41]" data-testid="footer-copyright-line">
        {t("footer.copy")}
      </div>
    </footer>
  );
}
